import React from "react";
import { useTranslation } from "react-i18next";
import { BMCsWithRatingStatuses } from "src/resources/enum";
import "src/scss/_theme.scss";
import { getCompanyPaymentStatus } from "src/utils/common";

interface PaymentStatusProps {
  status?: any;
}

const PaymentStatus: React.FC<PaymentStatusProps> = ({ status }) => {
  const { t } = useTranslation(["invoice"]);
  const paymentStatus = getCompanyPaymentStatus(status);
  return (
    <span>
      {status === BMCsWithRatingStatuses.Cleared ? (
        <span className="oval green-oval">{t(paymentStatus)}</span>
      ) : (
        <span className="oval red-oval">{t(paymentStatus)}</span>
      )}
    </span>
  );
};

export default PaymentStatus;
